/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplyToAThreadRequest
 */
export interface ReplyToAThreadRequest {
    /**
     * 
     * @type {string}
     * @memberof ReplyToAThreadRequest
     */
    body: string;
}

/**
 * Check if a given object implements the ReplyToAThreadRequest interface.
 */
export function instanceOfReplyToAThreadRequest(value: object): value is ReplyToAThreadRequest {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function ReplyToAThreadRequestFromJSON(json: any): ReplyToAThreadRequest {
    return ReplyToAThreadRequestFromJSONTyped(json, false);
}

export function ReplyToAThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplyToAThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
    };
}

export function ReplyToAThreadRequestToJSON(json: any): ReplyToAThreadRequest {
    return ReplyToAThreadRequestToJSONTyped(json, false);
}

export function ReplyToAThreadRequestToJSONTyped(value?: ReplyToAThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
    };
}

